/* ============================================================
   Mega-menu hover-intent
   ------------------------------------------------------------
   The dropdown sub-columns (`.menu-type-dropdown-inner`) are
   shown via pure CSS `:hover`. That breaks when the user moves
   the cursor diagonally from a parent item toward its submenu
   item — the cursor passes over OTHER parent items on the way,
   each gets `:hover`, the right column flickers and swaps, and
   the target item disappears before the cursor reaches it.

   This script replaces pure-`:hover` activation with a
   JS-controlled `.is-mm-active` class plus open/close timers,
   so a momentary mouseenter on a different parent during a
   diagonal traverse doesn't switch the active submenu.
   ============================================================ */
(function () {
  'use strict';

  if (typeof document === 'undefined') return;

  var OPEN_DELAY  = 90;   // ms before activating a newly hovered parent
  var CLOSE_DELAY = 280;  // ms grace period after leaving the active parent

  // Inject CSS that:
  //   1. neutralises the existing :hover rule for show/hide
  //   2. shows the submenu only when JS has applied .is-mm-active
  // Specificity is matched (4 classes), and source order makes this win.
  var styleId = 'mm-hover-intent-styles';
  if (!document.getElementById(styleId)) {
    var style = document.createElement('style');
    style.id = styleId;
    style.textContent =
      '.dropdown-inner-menu-item.menu-type-dropdown.has-children:hover > .menu-type-dropdown-inner {' +
        'visibility: hidden;' +
        'pointer-events: none;' +
        'opacity: 0;' +
        'clip-path: polygon(0 0,0 0,0 100%,0% 100%);' +
      '}' +
      '.dropdown-inner-menu-item.menu-type-dropdown.has-children.is-mm-active > .menu-type-dropdown-inner,' +
      '.dropdown-inner-menu-item.menu-type-dropdown.has-children.is-mm-active:hover > .menu-type-dropdown-inner {' +
        'visibility: visible !important;' +
        'pointer-events: auto !important;' +
        'opacity: 1 !important;' +
        'clip-path: polygon(101% 0, 0 0, 0 101%, 101% 101%) !important;' +
      '}';
    (document.head || document.documentElement).appendChild(style);
  }

  function init() {
    var openTimer = null;
    var closeTimer = null;
    var activeParent = null;
    var pendingParent = null;

    function activate(parent) {
      if (activeParent === parent) return;
      if (activeParent) activeParent.classList.remove('is-mm-active');
      activeParent = parent;
      if (parent) parent.classList.add('is-mm-active');
    }

    function bind(parent) {
      // Mark so we don't double-bind on re-runs
      if (parent._mmBound) return;
      parent._mmBound = true;

      parent.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);

        if (parent === activeParent) {
          pendingParent = null;
          return;
        }

        // Schedule activation; if the user moves on before the timer
        // fires, the new mouseenter resets the schedule below.
        pendingParent = parent;
        clearTimeout(openTimer);
        openTimer = setTimeout(function () {
          if (pendingParent === parent) activate(parent);
        }, OPEN_DELAY);
      });

      parent.addEventListener('mouseleave', function () {
        // Cancel a pending activation if cursor is leaving before commit
        if (pendingParent === parent) {
          pendingParent = null;
          clearTimeout(openTimer);
        }
        // Grace period for diagonal traversal toward the open submenu
        if (parent === activeParent) {
          clearTimeout(closeTimer);
          closeTimer = setTimeout(function () {
            if (parent === activeParent) activate(null);
          }, CLOSE_DELAY);
        }
      });

      // If the cursor enters this parent's own submenu, keep it open
      var submenu = parent.querySelector(':scope > .menu-type-dropdown-inner');
      if (submenu) {
        submenu.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
          if (activeParent !== parent) activate(parent);
        });
        submenu.addEventListener('mouseleave', function () {
          clearTimeout(closeTimer);
          closeTimer = setTimeout(function () {
            if (parent === activeParent) activate(null);
          }, CLOSE_DELAY);
        });
      }
    }

    function bindAll() {
      document
        .querySelectorAll('.dropdown-inner-menu-item.menu-type-dropdown.has-children')
        .forEach(bind);
    }

    bindAll();

    // The header markup is server-rendered, but observe in case any
    // app re-renders the menu (e.g., translation, A/B test apps).
    if ('MutationObserver' in window) {
      new MutationObserver(bindAll).observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
